import { useCountdown } from "@/utils/useCountdown"
import { zordDbDatetimeToStr } from "@/utils/zordDbDatetimeToStr"

export function Counter({ dataFim }: Readonly<{ dataFim: string }>) {
    const tempoRestante = useCountdown(dataFim)
        
    if (!dataFim) return null

    return (
        <div className="oferta-countdown">
            <div data-fim={zordDbDatetimeToStr(dataFim)} data-diff-days="true">
                <div className="text-contador">
                    Corra, a oferta acaba em:
                </div>
                <div className="alinha-contador">
                    {tempoRestante && (
                        <div className="ctn dia">
                            <span className="count">{tempoRestante.dias}d</span>
                            <span className="text">:</span>
                        </div>
                    )}
                    <div className="ctn hora">
                        <span className="count">{tempoRestante.horas}h</span>
                        <span className="text">:</span>
                    </div>
                    <div className="ctn min">
                        <span className="count">{tempoRestante.minutos}m</span>
                        <span className="text">:</span>
                    </div>
                    <div className="ctn seg">
                        <span className="count">{tempoRestante.segundos}s</span>
                        <span className="text"></span>
                    </div>
                </div>
            </div>
        </div>
    )
}